import React from "react";
import { Box, Typography, Link } from "@mui/material";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import { useAccount } from "../../context/AccountContext";
import { QUIZ } from "@/theme/quizTokens";

/**
 * Issue #55 (1): temporary stopgap until self-serve reactivation ships.
 * Shows on every portal page for customers whose plans are all paused
 * (i.e. they have subscriptions but none active).
 *
 * Deliberately behind one flag so it can be switched off in a single line
 * when reactivation goes live.
 */
export const SHOW_PAUSED_PLAN_BANNER = true;

const SUPPORT_EMAIL = "support@pawsonplates.com";

export function PausedPlanBanner() {
  const { hasSubs, activeSubsCount } = useAccount();

  if (!SHOW_PAUSED_PLAN_BANNER) return null;
  if (!hasSubs || activeSubsCount > 0) return null;

  return (
    <Box
      role="alert"
      sx={{
        display: "flex",
        alignItems: "flex-start",
        gap: 1.25,
        background: "#c62828",
        borderRadius: "12px",
        px: 2,
        py: 1.5,
        mb: 2,
      }}
    >
      <ErrorOutlineIcon sx={{ fontSize: 20, color: "#fff", mt: "1px", flexShrink: 0 }} />
      <Typography
        sx={{
          fontFamily: QUIZ.font.body,
          fontSize: 14,
          fontWeight: 600,
          color: "#fff",
          lineHeight: 1.45,
        }}
      >
        Your meal plans are paused — please email us at{" "}
        <Link
          href={`mailto:${SUPPORT_EMAIL}`}
          sx={{
            color: "#fff",
            fontWeight: 700,
            textDecoration: "underline",
            textDecorationColor: "rgba(255,255,255,0.7)",
            "&:hover": { textDecorationColor: "#fff" },
          }}
        >
          {SUPPORT_EMAIL}
        </Link>{" "}
        to reactivate.
      </Typography>
    </Box>
  );
}
